<script>
import ErrorPage from "./ErrorPage.vue";

export default {
    name: 'ErrorBoundary',
    components: {ErrorPage},
    data() {
        return {
            error: false,
        };
    },
    errorCaptured(err, vm, info) {
        this.error = true;
        dev.log(`${err.stack}\n\nfound in ${info} of component ${vm.$options.name}`);
    }
};
</script>

<template>
    <div class="fhw">
        <ErrorPage v-if="error"/>
        <slot v-else></slot>
    </div>
</template>
<style scoped>
.fhw {
    height: 100%;
    width: 100%;
}
</style>

